import { _baseFormat } from '../shared/base-format';
import { addHours as addHoursFn, subHours as subHoursFn } from 'date-fns';
/**
 *  Calculates the local time and formats it as HH:mm.
 *
 * @returns {string} - The current formatted time.
 */
export const localTime = () => _baseFormat(new Date(), 'HH:mm');
/**
 * Adds a specified number of hours onto a provided date.
 *
 * @param {Date} date - The date that is to be updated.
 * @param {number} hours - The number of hours to be added on.
 * @returns {Date} - The original date with the number of hours adjusted.
 */
export const addHours = (date, hours) => addHoursFn(date, hours);
/**
 * Subtracts a specified number of hours from a provided date.
 *
 * @param {Date} date - The date that is to be updated.
 * @param {number} hours - The number of hours to be subtracted.
 * @returns {Date} - The original date with the number of hours adjusted.
 */
export const subHours = (date, hours) => subHoursFn(date, hours);
//# sourceMappingURL=time-helpers.js.map